const buttonClasses = 'bg-secondaryGreen-600 text-neutrals-900';

const buttonHoverClasses = 'hover:bg-secondaryGreen-900';

const buttonIconClasses = 'fill-neutrals-900';

const buttonSecondaryGreenClasses = {
  buttonBlogVariantClasses: [buttonClasses, buttonHoverClasses],
  buttonIconClasses,
};

export default buttonSecondaryGreenClasses;
